import MDTypography from "components/MDTypography";
import { ComponentProps } from "react";
import { draftColors, draftTypography } from "modules/proposals/draft/draftDesignTokens";

type MDTypographyProps = ComponentProps<typeof MDTypography>;

type UiTypographyVariant =
  | "heading-lg"
  | "heading-sm"
  | "body"
  | "body-sm"
  | "caption"
  | "label"
  | "label-xs"
  | "overline"
  | "overline-lg"
  | "accent-bold";

type UiTypographyProps = Omit<MDTypographyProps, "variant"> & {
  uiVariant?: UiTypographyVariant;
};

const variantStyles: Record<UiTypographyVariant, Record<string, unknown>> = {
  "heading-lg": {
    color: draftColors.textPrimary,
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: draftTypography.title.lineHeight,
  },
  "heading-sm": {
    color: draftColors.textPrimary,
    fontSize: draftTypography.body14.fontSize,
    fontWeight: 700,
    lineHeight: draftTypography.body14.lineHeight,
  },
  body: {
    color: draftColors.textPrimary,
    fontSize: draftTypography.body14.fontSize,
    fontWeight: 400,
    lineHeight: draftTypography.body14.lineHeight,
  },
  "body-sm": {
    color: draftColors.textPrimary,
    fontSize: draftTypography.body12.fontSize,
    fontWeight: draftTypography.body12.fontWeight,
    lineHeight: draftTypography.body12.lineHeight,
  },
  caption: {
    color: draftColors.textSecondary,
    fontSize: draftTypography.body12.fontSize,
    fontWeight: draftTypography.body12.fontWeight,
    lineHeight: draftTypography.body12.lineHeight,
  },
  label: {
    color: draftColors.textSecondary,
    fontSize: draftTypography.label11.fontSize,
    fontWeight: draftTypography.label11.fontWeight,
    lineHeight: draftTypography.label11.lineHeight,
    letterSpacing: draftTypography.label11.letterSpacing,
    textTransform: "uppercase",
  },
  "label-xs": {
    color: draftColors.textSecondary,
    fontSize: draftTypography.label9.fontSize,
    fontWeight: draftTypography.label9.fontWeight,
    lineHeight: draftTypography.label9.lineHeight,
    letterSpacing: draftTypography.label9.letterSpacing,
    textTransform: "uppercase",
  },
  overline: {
    color: draftColors.textPrimary,
    fontSize: draftTypography.label12Semi.fontSize,
    fontWeight: draftTypography.label12Semi.fontWeight,
    lineHeight: draftTypography.label12Semi.lineHeight,
  },
  "overline-lg": {
    color: draftColors.textPrimary,
    fontSize: draftTypography.body14.fontSize,
    fontWeight: 700,
    lineHeight: draftTypography.title.lineHeight,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
  },
  "accent-bold": {
    color: draftColors.textAction,
    fontSize: draftTypography.body14Bold.fontSize,
    fontWeight: draftTypography.body14Bold.fontWeight,
    lineHeight: draftTypography.body14Bold.lineHeight,
  },
};

export default function UiTypography({ uiVariant = "body-sm", sx, ...rest }: UiTypographyProps) {
  return <MDTypography sx={{ ...variantStyles[uiVariant], ...sx }} {...rest} />;
}
